import React, {useState} from 'react';
import {t} from '@lingui/core/macro';

import PromosIcon from 'shared/ui/icons/NavMenu/PromosIcon';
import Button from 'shared/ui/Button/Button/Button';

import PromoCodeActivateModal from './PromoCodeActivateModal';

import styles from './PromoCodeBanner.module.scss';

const PromoCodeBanner: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div className={styles.banner}>
            <span className={styles.icon}>
                <PromosIcon/>
            </span>
            <span className={styles.text}>
                {t`Есть промокод? Активируйте его и получите платный тариф бесплатно`}
            </span>
            <Button
                type="button"
                className={styles.button}
                onClick={() => setIsModalOpen(true)}
            >
                {t`Есть промокод?`}
            </Button>
            <PromoCodeActivateModal
                open={isModalOpen}
                handleClose={() => setIsModalOpen(false)}
            />
        </div>
    );
};

export default PromoCodeBanner;
